import React from 'react';
import PropTypes from 'prop-types';
import { CSSTransition, TransitionGroup } from 'react-transition-group';

const ReactCSSTransitionGroupCompat = ({
  children,
  transitionName,
  transitionEnterTimeout,
  transitionLeaveTimeout,
  transitionAppear,
  transitionAppearTimeout,
  component,
  ...props
}) => {
  const timeout = {
    enter: transitionEnterTimeout || 0,
    exit: transitionLeaveTimeout || 0,
    appear: transitionAppearTimeout || transitionEnterTimeout || 0
  };

  return (
    <TransitionGroup component={component} {...props}>
      {React.Children.map(children, (child, index) => child && (
        <CSSTransition
          key={child.key || index}
          classNames={transitionName}
          timeout={timeout}
          appear={transitionAppear}
        >
          {child}
        </CSSTransition>
      ))}
    </TransitionGroup>
  );
};

ReactCSSTransitionGroupCompat.defaultProps = {
  component: 'span'
};

ReactCSSTransitionGroupCompat.propTypes = {
  children: PropTypes.node,
  transitionName: PropTypes.string.isRequired,
  transitionEnterTimeout: PropTypes.number,
  transitionLeaveTimeout: PropTypes.number,
  transitionAppear: PropTypes.bool,
  transitionAppearTimeout: PropTypes.number,
  component: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.func
  ])
};

export default ReactCSSTransitionGroupCompat;
